import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { OrdemTransporte } from '../../types/logistica';
import { ordensTransporteService } from '../../services';

const columns: ResourceColumn<OrdemTransporte>[] = [
  { header: "Caminhão", accessor: "caminhao_display" },
  { header: "Motorista", accessor: "motorista_display" },
  { header: "Origem", accessor: "origem" },
  { header: "Destino", accessor: "destino" },
  { header: "Data Saída", accessor: "data_saida" },
  { header: "Status", accessor: "status" },
];

export const OrdensTransporteListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ResourceListPage
      title="Ordens de Transporte"
      description="Gestão de ordens de transporte e logística."
      columns={columns}
      service={ordensTransporteService}
      createPath="/admin/logistica/ordens-transporte/novo"
      onEdit={(item) => item.id && navigate(`/admin/logistica/ordens-transporte/${item.id}`)}
    />
  );
};
